import { Router } from '@angular/router';
import { LoginService } from './../services/login.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public _loginService: LoginService,private router:Router) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${this._loginService.getToken()}`
      }
    });
    // return next.handle(request).
    // return next.handle(request).do((event: HttpEvent<any>) => {},
    // (err: any) => {
    //   if (err instanceof HttpErrorResponse) {
    //     if (err.status === 401) {
    //         this.router.navigate(['login']);
    //     }
    //   }
    // });
    return next.handle(request);
  }
}